import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";
import { cryptoTokenDecode } from "./../components/Common/Common";
import * as message from "./../config/CommonMessages";

/**
 *
 * @desc User - Buyer Agent registration API call
 */
export function registerUserAction(data) {
  // console.log("registerUserAction data: ", data);
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.RegisterUrl, data, false).then(
      (response) => {
        // console.log("registerUserAction response: ", response);
        if (response.status === code.OK) {
          if (response.data === "User already registered.") {
            dispatch({
              type: types.REGISTER_USER,
              status: false,
              RegMessage: "Email address already exist.",
            });
          } else {
            dispatch({
              type: types.REGISTER_USER,
              status: true,
              RegMessage:
                "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
            });
          }
        } else {
          dispatch({
            type: types.REGISTER_USER,
            status: false,
            RegMessage: "Something went wrong. Please try again!",
          });
        }
        return response;
      }
    );
  };
}

/**
 * 27-6-2023
 * registration api for invite accountowner from admin, to fulfill remaining details, and create user at auth and billing module.
 */
export function registerInvitedAccounowner(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.RegisterinvitedAccounowner,
      data,
      false
    ).then((response) => {
      if (response.status === code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc User - Buyer Agent registration without subscription API call
 */
export function registerUserWithoutPlanAction(data) {
  // console.log("registerUserWithoutPlanAction data: ", data);
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.RegisterWithoutPlanUrl,
      data,
      false
    ).then((response) => {
      // console.log("registerUserWithoutPlanAction response: ", response);
      if (response.status === code.OK) {
        if (response.data === "User already registered.") {
          dispatch({
            type: types.REGISTER_USER,
            status: false,
            RegMessage: "Email address already exist.",
          });
        } else {
          dispatch({
            type: types.REGISTER_USER,
            status: true,
            RegMessage:
              "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
          });
        }
      } else {
        dispatch({
          type: types.REGISTER_USER,
          status: false,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc Login User API call
 */

export function loginUserAction(data) {
  data = { data: data };
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.LoginUrl, data, false).then(
      (response) => {
        if (response.status === code.OK) {
          var accessToken = response.data;
          localStorage.setItem("accessToken", accessToken);
          var playload = cryptoTokenDecode();
          localStorage.setItem("usertype", playload.usertype);
          localStorage.setItem("ID", playload._id);
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: true,
            LoginMessage: "",
          });
        } else if (response.status === code.FORBIDDEN) {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage:
              "Your account is still under review. Please try again later.",
          });
        } else if (response.status === code.BAD_REQUEST) {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage: response.data,
          });
        } else {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage: "Wrong username or password.",
          });
        }
        return response;
      }
    );
  };
}
/**
 * New api for new login with user name. not by email.
 * 28-12-2022
 * @param {*} data
 * @returns
 */
export function loginUserActionNew(data) {
  data = { data: data };
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.LoginUrl + "/new", data, false).then(
      (response) => {
        if (response.status === code.OK) {
          // console.log("response.data", response.data);
          // var accessToken = response.data.data;
          // localStorage.setItem("accessToken", accessToken);
          // var playload = cryptoTokenDecode();
          // localStorage.setItem("usertype", playload.usertype);
          // localStorage.setItem("ID", playload._id);
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: true,
            LoginMessage: "",
          });
        } else if (response.status === code.FORBIDDEN) {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage:
              "Your account is still under review. Please try again later.",
          });
        } else if (response.status === code.BAD_REQUEST) {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage: response.data,
          });
        } else {
          dispatch({
            type: types.LOGIN_USER,
            isAuthenticated: false,
            LoginMessage: "Wrong username or password.",
          });
        }
        return response;
      }
    );
  };
}
/**
 *
 * @desc List Registration requests API call
 */

export function registrationRequestsAction(
  recordPerPage,
  lastSyncTimestamp,
  pageIndex
) {
  var url = UrlConstants.RegistrationRequestsUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var finalurl = url.replace("{modifieddate}", lastSyncTimestamp);
  var replacedUrl = finalurl.replace("{pageIndex}", pageIndex);

  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REGISTRATION_REQUESTS,
          users: response.data.data,
          totalUsers: response.data.total,
        });
      } else {
        dispatch({
          type: types.REGISTRATION_REQUESTS,
          users: {},
        });
      }

      return response.data;
    });
  };
}

/**
 *
 * @desc Logout action
 */
export function logout() {
  return function(dispatch) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("usertype");
    localStorage.removeItem("currentRole");
    localStorage.removeItem("taskType");
    // localStorage.removeItem("templateCount");
    localStorage.removeItem("transactionCount");
    localStorage.removeItem("templateLimit");
    localStorage.removeItem("transactionLimit");
    localStorage.removeItem("price");
    localStorage.removeItem("interval");
    // localStorage.removeItem(code.IS_STRIPE_ENABLED);
    dispatch({
      type: types.LOGOUT,
    });
  };
}

/**
 *
 * @desc Active buyer agent API call
 */
export function removeRegistartionAction(userID) {
  return function(dispatch) {
    let url = UrlConstants.removeRegistrationRequest + userID;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REMOVED_REGISTRATION,
          status: true,
          UserMessage: "Registration Request has been removed.",
        });
      } else {
        dispatch({
          type: types.REMOVED_REGISTRATION,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc reject buyer agent API call
 */
export function rejectRegistartionsListAction(recordPerPage, pageIndex) {
  var url = UrlConstants.rejectedRegistrationList.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REJECT_REGISTRATION_LIST,
          status: true,
          users: response.data.data,
          totalRejectedUsers: response.data.total,
        });
      } else {
        dispatch({
          type: types.REJECT_REGISTRATION_LIST,
          status: false,
          users: {},
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc reject buyer agent API call
 */
export function rejectRegistartionAction(userID) {
  return function(dispatch) {
    let url = UrlConstants.rejectRegistrationRequest + userID;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REJECT_REGISTRATION,
          status: true,
          UserMessage: "Registration Request has been rejected.",
        });
      } else {
        dispatch({
          type: types.REJECT_REGISTRATION,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc Active buyer agent API call
 */
export function activeUserAction(userID) {
  return function(dispatch) {
    var data = {
      action: "APPROVE",
    };
    var url = UrlConstants.ApproveUserAccountUrl.replace("{userID}", userID);
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ACTIVE_USER,
          status: true,
          UserMessage: "User has been activated.",
        });
      } else {
        dispatch({
          type: types.ACTIVE_USER,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
    });
  };
}
/**
 *
 * @desc List Buyer Agents API call
 */
export function buyerAgentsAction(recordPerPage, pageIndex, plan) {
  var url = UrlConstants.BuyerAgentListUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  // replacedUrl = replacedUrl + "&role=Artist";

  if (plan != "") {
    replacedUrl = replacedUrl + `&role=Artist` + `&plan=${plan}`;
  } else {
    replacedUrl = replacedUrl + `&role=Artist`;
  }
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          buyerAgents: response.data.data,
          totalBuyerAgents: response.data.total,
        });
      } else {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          buyerAgents: {},
        });
      }
    });
  };
}


export function getAllOwnersData(recordPerPage, pageIndex, plan) {
  var url = UrlConstants.getAllOwnersData.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  // replacedUrl = replacedUrl + "&role=Artist";

  if (plan != "") {
    replacedUrl = replacedUrl + `&role=Artist` + `&plan=${plan}`;
  } else {
    replacedUrl = replacedUrl + `&role=Artist`;
  }
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          buyerAgents: response.data.data,
          totalBuyerAgents: response.data.total,
        });
      } else {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          buyerAgents: {},
        });
      }
    });
  };
}
/**
 *
 * @desc GET profile details of logged in user
 */
export function myProfileAction(id) {
  return function(dispatch) {
    let finalURL = "";
    let USERID = "";
    if (id) {
      USERID = id;
      finalURL = UrlConstants.getProfileUrl + id;
    } else {
      finalURL = UrlConstants.MyProfileUrl;
    }
    return APIUtil.getMethod(finalURL, true).then((response) => {
      // console.log("myProfileAction response: ", response.data);
      if (response.status === code.OK) {
        if (USERID == "") {
          localStorage.setItem("fname", response.data.firstname);
          localStorage.setItem("lname", response.data.lastname);
          localStorage.setItem("ID", response.data._id);
          localStorage.setItem("color", response.data.color);
          localStorage.setItem("email", response.data.email.address);
          // localStorage.setItem(
          //   "isActive",
          //   !!response.data.subsriptionDetails
          //     ? response.data.subsriptionDetails.isActive
          //     : "true"
          // );
          // localStorage.setItem(
          //   "priceId",
          //   !!response.data.subsriptionDetails
          //     ? response.data.subsriptionDetails.priceId
          //     : ""
          // );
          // localStorage.setItem(
          //   "productId",
          //   !!response.data.subsriptionDetails
          //     ? response.data.subsriptionDetails.productId
          //     : ""
          // );
          // localStorage.setItem(
          //   "subscriptionId",
          //   !!response.data.subsriptionDetails
          //     ? response.data.subsriptionDetails.subscriptionId
          //     : ""
          // );
          // localStorage.setItem(
          //   "customerId",
          //   !!response.data.subsriptionDetails
          //     ? response.data.subsriptionDetails.customerId
          //     : ""
          // );
          // localStorage.setItem(
          //   "companyName",
          //   !!response.data.companyInformation
          //     ? response.data.companyInformation.name
          //     : ""
          // );
          // if (response.data.isSubscriptionEnabled) {
          //   localStorage.setItem(code.IS_STRIPE_ENABLED, "true");
          // } else {
          //   localStorage.setItem(code.IS_STRIPE_ENABLED, "false");
          // }
          // if (response.data.usertype === "VENDOR") {
          //   localStorage.setItem("currentRole", "BUYERAGENT");
          // }
          // if (response.data.usertype === "BUYER") {
          //   localStorage.setItem("currentRole", "BUYER");
          // }
        }
        dispatch({
          type: types.MY_PROFILE,
          profileData: response.data,
        });
      } else {
        dispatch({
          type: types.MY_PROFILE,
          profileData: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc User - Update user details
 */
export function updateProfileAction(data) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.MyProfileUrl, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.UPDATE_PROFILE,
            updatedProfileData: response,
          });
        } else {
          dispatch({
            type: types.UPDATE_PROFILE,
            updatedProfileData: {},
          });
        }
      }
    );
  };
}

/**
 *
 * @desc User - Update user details by id
 */
export function updateUserProfileAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.getProfileUrl + id, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.UPDATE_PROFILE,
            updatedProfileData: response,
          });
        } else {
          dispatch({
            type: types.UPDATE_PROFILE,
            updatedProfileData: {},
          });
        }
      }
    );
  };
}

/**
 *
 * @desc Admin - Create/Invite Buyer Agent API call
 */
export function inviteAgentAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.InviteAgentUrl, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADMIN_INVITE_AGENT,
            checkStatus: true,
            invieAgentMsg: "Buyer Agent has been added successfully.",
          });
        } else {
          dispatch({
            type: types.ADMIN_INVITE_AGENT,
            checkStatus: false,
            invieAgentMsg: "Something went wrong. Please try again!",
          });
        }
      }
    );
  };
}
/**
 *
 * @desc Admin - Create/Invite Buyer Agent API call
 */
export function inviteAgentWithoutPlanAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.RegisterWithoutPlanUrl,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADMIN_INVITE_AGENT,
          checkStatus: true,
          invieAgentMsg: "Buyer Agent has been added successfully.",
        });
      } else {
        dispatch({
          type: types.ADMIN_INVITE_AGENT,
          checkStatus: false,
          invieAgentMsg: "Something went wrong. Please try again!",
        });
      }
    });
  };
}

/**
 *
 * @desc Get All Contacts
 */

// export function getContactsActions(type, id) {
//     let finalURL = ''
//     if (type == 'buyer') {
//         finalURL = UrlConstants.homeBuyerContacts + id;
//     } else if (type == 'contactList') {
//         finalURL = UrlConstants.addContact + (id || '');
//     }
//     else {
//         finalURL = UrlConstants.addContact + (id || '');
//     }

//     return function (dispatch) {
//         return APIUtil.getMethod(finalURL, true).then(response => {
//             if (response.status == code.OK || response.status == code.NOT_MODIFIED) {
//                 dispatch({
//                     type: types.GET_CONTACT,
//                     contacts: response.data
//                 });
//             }
//             else {
//                 dispatch({
//                     type: types.GET_CONTACT,
//                     contacts: []
//                 });
//             }
//             return response
//         });
//     }
// }

//my  code

export function getContactsActions(type, id) {
  let finalURL = "";
  //  console.log("========type==================================================",type)
  // console.log("========id====",id)
  if (type == "buyer") {
    finalURL = UrlConstants.homeBuyerContacts + id;
  } else if (type == "contactList") {
    finalURL = UrlConstants.addContact + (id || "");
  } else if (type == "Artist" || type == "Artist") {
    finalURL = UrlConstants.addContact + "?role=Artist";
  } else if (type == "Client") {
    finalURL = UrlConstants.addContact + "?role=Client";
  } else {
    finalURL = UrlConstants.addContact + (id || "");
  }

  return function(dispatch) {
    return APIUtil.getMethod(finalURL, true).then((response) => {
      if (response.status == code.OK || response.status == code.NOT_MODIFIED) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get All Contacts
 */

export function getContactByIdAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.addContact + "?id=" + id, true).then(
      (response) => {
        var contactData = {};
        response.data.filter((value) => {
          if (value.contactId == id) {
            contactData = value;
          }
        });

        if (response) {
          dispatch({
            type: types.GET_BY_ID_CONTACT,
            contact: contactData,
          });
        } else {
          dispatch({
            type: types.GET_BY_ID_CONTACT,
            contact: {},
          });
        }
      }
    );
  };
}

/**
 *
 * @desc Check email or mobile is unique .(new api 22-12-2022)
 */

export function CheckEmailOrMobileUnique(value, value1, id) {
  // console.log("VALUE at useraction", value);
  // console.log("type of", typeof value);
  // console.log("VALUE11", value1);
  // console.log("type of at useraction VALUE11", typeof value1);
  // console.log("id at useraction", id);
  let url;

  if (
    (typeof value === "string" || value instanceof String) &&
    value1 == undefined
  ) {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUnique?email=" +
      value +
      "&Ownerid=" +
      localStorage.getItem("ID") +
      "&id=" +
      id;
  } else if (
    (typeof value1 === "string" || value1 instanceof String) &&
    value == undefined
  ) {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUnique?mobile=" +
      value1 +
      "&Ownerid=" +
      localStorage.getItem("ID") +
      "&id=" +
      id;
  } else {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUnique?mobile=" +
      value1 +
      "&email=" +
      value +
      "&Ownerid=" +
      localStorage.getItem("ID") +
      "&id=" +
      id;
  }
  // console.log("url", url);

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response.data;
    });
  };
}

/**
 * new function for check email or mobile unique for add contact
 * 5-1-23
 */
export function CheckEmailOrMobileUniqueatAddContact(value, value1) {
  // console.log("VALUE at useraction", value);
  // console.log("type of", typeof value);
  // console.log("VALUE11", value1);
  // console.log("type of at useraction VALUE11", typeof value1);
  let url;

  if (
    (typeof value === "string" || value instanceof String) &&
    value1 == undefined
  ) {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUniqueatregistration?email=" +
      value +
      "&Ownerid=" +
      localStorage.getItem("ID");
  } else if (
    (typeof value1 === "string" || value1 instanceof String) &&
    value == undefined
  ) {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUniqueatregistration?mobile=" +
      value1 +
      "&Ownerid=" +
      localStorage.getItem("ID");
  } else {
    url =
      UrlConstants.addContact +
      "/CheckEmailOrMobileUniqueatregistration?mobile=" +
      value1 +
      "&email=" +
      value +
      "&Ownerid=" +
      localStorage.getItem("ID");
  }
  // console.log("url", url);

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Get All Contacts
 */

// export function getContactByEmailAction(value) {
//     console.log("VALUE",value)
//     console.log("type of",typeof value)
//     let url;

//     if(typeof value === 'string' || value instanceof String)
//     {
//         url = UrlConstants.addContact + "/email?email=" + value +"&Ownerid="+localStorage.getItem("ID")
//     }
//     else{
//         url = UrlConstants.addContact + "/email?mobile=" + value +"&Ownerid="+localStorage.getItem("ID")
//     }

//     return function (dispatch) {
//         return APIUtil.getMethod(url, true).then(response => {

//             if (response) {
//                 dispatch({
//                     type: types.GET_BY_ID_CONTACT,
//                     contact: response
//                 });
//             }
//             else {
//                 dispatch({
//                     type: types.GET_BY_ID_CONTACT,
//                     contact: {}
//                 });
//             }
//             return response.data;
//         });
//     }
// }
/**
 *
 * @desc Get All Contacts
 */

export function getContactByEmailAction(email) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.addContact + "/email?email=" + email,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Add contact
 */
export function addContactAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.addContact, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_CONTACT,
            contactResponse: response,
            RegMessage:
              "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
          });
        } else {
          dispatch({
            type: types.ADD_CONTACT,
            contactResponse: response,
            RegMessage: "Something went wrong. Please try again!",
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Add  contact Action New 22-12-2022
 */
export function addContactActionNew(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/AddContactNew",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage:
            "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Edit contact
 */
export function editContactAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      }

      return response.data;
    });
  };
}

/**
 * new edit artist or client updation calling.
 * 3-1-2023
 */
export function editContactActionNew(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "/newUpdate" + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      }

      return response.data;
    });
  };
}

/**
 * update contact dsd data
 *
 */
export function editContactDsdDataAction(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "/userProfileUpdate",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      }

      return response.data;
    });
  };
}

/**
 *
 * @desc Edit contact
 */
export function editSetAsDefaultContactAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "/default?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      }
    });
  };
}

/**
 *
 * @desc Delete contact
 */
export function deleteContactAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.addContact + "?id=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      }
    });
  };
}

export function editRolesAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.roles + "/" + id, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.GET_ALL_ROLES,
            roles: response.data,
          });
        } else {
          dispatch({
            type: types.GET_ALL_ROLES,
            roles: response.data,
          });
        }

        return response.data || [];
      }
    );
  };
}

export function deleteRolesAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(UrlConstants.roles + "/" + id, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.GET_ALL_ROLES,
            roles: response.data,
          });
        } else {
          dispatch({
            type: types.GET_ALL_ROLES,
            roles: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

/**
 *
 * @desc Get User Roles
 */

export function getUserRolesAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.userRole + (id || "?id=" + localStorage.getItem("ID")),
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_ROLES,
          roles: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ROLES,
          roles: [],
        });
      }
      return response ? response.data : [];
    });
  };
}

/**
 *
 * @desc Add New User Roles
 */

export function addUserRolesAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.userRole, data, true).then(
      (response) => {
        if (response) {
          dispatch({
            type: types.ADD_ROLES,
            roles: response.data,
          });
        } else {
          dispatch({
            type: types.ADD_ROLES,
            roles: [],
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Forgot Password API call
 */

export function forgotPasswordAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.forgotpassword, data, false).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotsuccess: response.data,
          });
        } else {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotdata: response.data,
          });
        }
        return response;
      }
    );
  };
}

/**
 * new forgot api all for new routes
 * 30-12-2022
 */
export function NewforgotPasswordAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.forgotpasswordNew, data, false).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotsuccess: response.data,
          });
        } else {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotdata: response.data,
          });
        }
        return response;
      }
    );
  };
}
/**
 * new forgot username api
 * 2-1-2022
 */
export function forgotUserNameNew(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.forgotUserNameNew, data, false).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotsuccess: response.data,
          });
        } else {
          dispatch({
            type: types.FORGOT_PASSWORD,
            forgotdata: response.data,
          });
        }
        return response;
      }
    );
  };
}
export function validateResetTokenAction(Token, apidata, module) {
  return function(dispatch) {
    let final = "";
    if (module) {
      final = UrlConstants.setVendorPassword;
    } else {
      final = UrlConstants.validateResetPasswordToken + Token;
    }
    return APIUtil.postMethod(final, apidata).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.VALIDATE_RESET_TOKEN,
          tokensuccess: response.data,
        });
      } else {
        dispatch({
          type: types.VALIDATE_RESET_TOKEN,
          tokenfailed: response.data,
        });
      }
      return response;
    });
  };
}
/**
 * reset passward calling end point change for changing the email dependancy.
 * 6-1-2023
 */
export function validateResetTokenActionNew(Token, apidata, module) {
  return function(dispatch) {
    let final = "";
    if (module) {
      final = UrlConstants.setVendorPassword;
    } else {
      final = UrlConstants.validateResetPasswordTokenNew + Token;
    }
    return APIUtil.postMethod(final, apidata).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.VALIDATE_RESET_TOKEN,
          tokensuccess: response.data,
        });
      } else {
        dispatch({
          type: types.VALIDATE_RESET_TOKEN,
          tokenfailed: response.data,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc List Vendor User List API call
 */
export function vendorUserAction(recordPerPage, pageIndex) {
  var url = UrlConstants.VendorsListUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.VENDORS_LIST,
          vendorUsers: response.data.data,
          totalVendors: response.data.total,
        });
      } else {
        dispatch({
          type: types.VENDORS_LIST,
          vendorUsers: {},
          totalVendors: null,
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc List Vendor User List API call
 */
export function homeBuyersUserAction(recordPerPage, pageIndex) {
  var url = UrlConstants.BuyerListUrl.replace("{recordPerPage}", recordPerPage);
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYERS_LIST,
          buyers: response.data.data,
          totalbuyers: response.data.total,
        });
      } else {
        dispatch({
          type: types.BUYERS_LIST,
          buyers: {},
          totalbuyers: null,
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc Active buyer agent API call
 */
export function removeUsersAction(userID) {
  return function(dispatch) {
    let url = UrlConstants.RegisterUrl + "?id=" + userID;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK || response.status == code.NOT_MODIFIED) {
        dispatch({
          type: types.REMOVED_USER,
          status: true,
          UserMessage: "User has been removed.",
        });
      } else {
        dispatch({
          type: types.REMOVED_USER,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc List Buyer Agents API call
 */
export function getAdminUsersAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.AdminUsersListUrl, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.LIST_ADMIN_USERS,
            adminUsers: response.data.data,
            totalAdminUsers: response.data.total,
          });
        } else {
          dispatch({
            type: types.LIST_ADMIN_USERS,
            adminUsers: {},
            totalAdminUsers: 0,
          });
        }
      }
    );
  };
}

/**
 *
 * @desc Add new admin user
 */
export function addAdminUserAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.AdminAddUserUrl, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADD_ADMIN_USER,
            addedAdminUser: response,
            isAdminAdded: true,
          });
        } else {
          dispatch({
            type: types.ADD_ADMIN_USER,
            addedAdminUser: response,
            isAdminAdded: false,
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Change password api call
 */
export function changePasswordAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.ChangePasswordUrl, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.CHANGE_PASSWORD,
            isPasswordChanged: true,
          });
        } else {
          dispatch({
            type: types.CHANGE_PASSWORD,
            isPasswordChanged: false,
          });
        }
        return response;
      }
    );
  };
}
/**
 * Change passward user new for deprecuating the email dependancy to the username.
 * 9-1-2023
 */

export function changePasswordActionNew(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.ChangePasswordUrlNew,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.CHANGE_PASSWORD,
          isPasswordChanged: true,
        });
      } else {
        dispatch({
          type: types.CHANGE_PASSWORD,
          isPasswordChanged: false,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get invited user details
 */

export function getInviteUserDetailAction(token) {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getInvitedUserDetail + token).then(
      (response) => {
        if (response) {
          dispatch({
            type: types.INVITED_USER,
            userDetails: response.data,
          });
        } else {
          dispatch({
            type: types.INVITED_USER,
            userDetails: [],
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Get pending profile list
 */

export function getPendingProfileListAction(recordPerPage, pageIndex) {
  var url = UrlConstants.getPendingProfileListUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response) {
        dispatch({
          type: types.PENDING_PROFILE,
          userDetails: response.data.data,
          totalPending: response.data.total,
        });
      } else {
        dispatch({
          type: types.PENDING_PROFILE,
          userDetails: [],
        });
      }
      return response;
    });
  };
}
/**
 *
 * @desc Get stripe setting
 */

export function getStripeSettingAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.stripeSetting, false).then(
      (response) => {
        if (response) {
          dispatch({
            type: types.STRIPE_SETTING,
            stripeEnable: response.data,
          });
        } else {
          dispatch({
            type: types.STRIPE_SETTING,
            stripeEnable: [],
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc User - Update buyer user email
 */
export function updateBuyerUserAction(data) {
  const url = UrlConstants.editBuyerUserEmailUrl + "/" + data.id;
  const postData = {
    email: data.email,
  };
  return function(dispatch) {
    return APIUtil.putMethod(url, postData, true).then((response) => {
      // dispatch({
      //     type: types.BUYER_AGENT_LIST,
      //     buyerAgents: response.status === code.OK ? response.data.data : {},
      //     totalBuyerAgents: response.status === code.OK ? response.data.total : 0
      // });
      return response;
    });
  };
}

/**
 *
 * @desc Reactivate buyerusers, vendors, homebuyers and admin users
 */
export function reActivateDeletedUserAction(userId) {
  const url = UrlConstants.reActivateDeletedUserUrl + "/" + userId;
  const postData = {
    id: userId,
  };
  return function(dispatch) {
    return APIUtil.putMethod(url, postData, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc Reactivate buyerusers, vendors, homebuyers and admin users
 */
export function activateAdminUser(userId) {
  const url = UrlConstants.activateAdminUser + "/" + userId;
  const postData = {
    id: userId,
  };
  return function(dispatch) {
    return APIUtil.putMethod(url, postData, true).then((response) => {
      return response;
    });
  };
}

export function reActivateDeletedContactAction(userId) {
  const url = UrlConstants.reActivateDeletedContactUrl + "?id=" + userId;
  const postData = {
    id: userId,
  };
  return function(dispatch) {
    return APIUtil.putMethod(url, postData, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc search buyerusers, vendors, homebuyers and admin users
 */
export function searchUserAction(userType, searchQuery, limit, offset, plan) {
  let url;
  // if (limit != undefined && offset != undefined) {
  //   url =
  //     UrlConstants.searchUserUrl +
  //     "/" +
  //     userType +
  //     "?searchKey=" +
  //     searchQuery +
  //     "&limit=" +
  //     limit +
  //     "&offset=" +
  //     offset;
  // } else {
  //   url =
  //     UrlConstants.searchUserUrl + "/" + userType + "?searchKey=" + searchQuery;
  // }
  if (limit !== undefined && offset !== undefined) {
    if (plan !== "") {
      url =
        UrlConstants.searchUserUrl +
        "/" +
        userType +
        "?searchKey=" +
        searchQuery +
        "&plan=" +
        plan +
        "&limit=" +
        limit +
        "&offset=" +
        offset;
    } else {
      url =
        UrlConstants.searchUserUrl +
        "/" +
        userType +
        "?searchKey=" +
        searchQuery +
        "&limit=" +
        limit +
        "&offset=" +
        offset;
    }
  } else {
    url =
      UrlConstants.searchUserUrl + "/" + userType + "?searchKey=" + searchQuery;
  }
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (userType == "buyeragent") {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          buyerAgents: response.status === code.OK ? response.data.data : [],
          totalBuyerAgents:
            response.status === code.OK ? response.data.total : null,
        });
      } else if (userType == "vendor") {
        dispatch({
          type: types.VENDORS_LIST,
          vendorUsers: response.status === code.OK ? response.data.data : [],
          totalVendors:
            response.status === code.OK ? response.data.total : null,
        });
      } else if (userType == "Buyer") {
        dispatch({
          type: types.BUYERS_LIST,
          buyers: response.status === code.OK ? response.data.data : [],
          totalbuyers: response.status === code.OK ? response.data.total : null,
        });
      } else if (userType == "admin") {
        dispatch({
          type: types.LIST_ADMIN_USERS,
          adminUsers: response.status === code.OK ? response.data.data : [],
          totalAdminUsers:
            response.status === code.OK ? response.data.total : null,
        });
      } else if (userType == "acctowner") {
        dispatch({
          type: types.BUYER_AGENT_LIST,
          adminUsers: response.status === code.OK ? response.data.data : [],
          totalAdminUsers:
            response.status === code.OK ? response.data.total : null,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get contacts with pagination and Searching :: New api of backend
 */
export function addContactActionWithPagination(data) {
  return function(dispatch) {
    let url = UrlConstants.addContact + "/fetchContacts";
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get Count of in-progress transactions before delete :: New api of backend
 */
export function GetCountofInProgressTransactions(id, role) {
  return function(dispatch) {
    let url =
      UrlConstants.addContact +
      "/checkAppointmentsBeforeDelete" +
      "?id=" +
      id +
      "&" +
      "role=" +
      role;
    return APIUtil.getMethod(url, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc Get billing setting
 */

export function getBillingSettingAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.billingSetting + code.APPICATION_NAME,
      false
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: response.data,
        });
      } else {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Register with Billing
 */
export function registerUserWithBillingAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.RegisterWithBillingUrl,
      data,
      false
    ).then((response) => {
      if (response.status === code.OK) {
        if (response.data === "User already registered.") {
          dispatch({
            type: types.REGISTER_USER,
            status: false,
            RegMessage: "Email address already exist.",
          });
        } else {
          dispatch({
            type: types.REGISTER_USER,
            status: true,
            RegMessage:
              "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
          });
        }
      } else {
        dispatch({
          type: types.REGISTER_USER,
          status: false,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Activate account owner with billing plan
 */
export function activateAccOwnerAction(postData) {
  return function(dispatch) {
    var data = {
      action: "APPROVE",
      planId: postData.planId,
      startDate: postData.startDate,
      endDate: postData.endDate,
    };
    var url = UrlConstants.ApproveUserAccountUrl.replace(
      "{userID}",
      postData.userId
    );
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ACTIVE_USER,
          status: true,
          UserMessage: "User has been activated.",
        });
      } else {
        dispatch({
          type: types.ACTIVE_USER,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc get current credit of account owner
 */
export function getCurrentCreditAction(userId) {
  return function(dispatch) {
    let url = UrlConstants.getCurrentCredit + userId;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_CURRENT_CREDIT,
          status: true,
        });
      } else {
        dispatch({
          type: types.GET_CURRENT_CREDIT,
          status: false,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc update current credit of account owner
 */
export function updateCurrentCreditAction(postData) {
  return function(dispatch) {
    var url = UrlConstants.updateCurrentCredit;
    return APIUtil.putMethod(url, postData, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.UPDATE_CURRENT_CREDIT,
          status: true,
          UserMessage: "Credit updated successfuly.",
        });
      } else {
        dispatch({
          type: types.UPDATE_CURRENT_CREDIT,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc change billing plan
 */
export function changeBillingPlanAction(postData) {
  return function(dispatch) {
    var url = UrlConstants.changeBillingPlan;
    return APIUtil.putMethod(url, postData, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.CHANGE_BILLING_PLAN,
          status: true,
          UserMessage: "Billing plan changed successfuly.",
        });
      } else {
        dispatch({
          type: types.CHANGE_BILLING_PLAN,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get contact permission roles
 */

export function getPermissonRolesAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.addContact + "/getPermissionRole",
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_ROLES,
          roles: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ROLES,
          roles: [],
        });
      }
      return response ? response.data : [];
    });
  };
}

/**
 *
 * @desc Get contacts Permissions with pagination and Searching
 */
export function contactsPermissionsListingAction(data) {
  return function(dispatch) {
    let url = UrlConstants.addContact + "/fetchPermissionContacts";
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Permenantly Delete contact permission
 */

export function deleteContactPermissionAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.addContact + "/deletePermissionContact?id=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      }
    });
  };
}

/**
 *
 * @desc Add  contact permission
 */
export function addContactPermissionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/AddPermissionContact",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage:
            "Thank you for registering with us. Our team will review your application and notify you once your account has been approved.",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *  Edit contact permission
 *
 */
export function editContactPermissionAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "/updatePermissionContact" + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
          RegMessage: "Contact updated!",
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get All Contacts for permissions
 */

export function getAuthorizedContactsActions() {
  return function(dispatch) {
    let usertype = cryptoTokenDecode().usertype;
    // console.log("usertype 2066", usertype);
    let url;
    if (usertype === "VENDOR") {
      let ownerId = localStorage.getItem("ownerId");
      url = UrlConstants.addContact + "/GetContactNew?ownerId=" + ownerId;
    } else {
      url = UrlConstants.addContact + "/GetContactNew";
    }
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 * get all permissions for vendors
 * 11-5-2023
 */

export function getallpermissions() {
  return function(dispatch) {
    let ownerId = localStorage.getItem("ownerId");
    let Id = localStorage.getItem("ID");
    let url = UrlConstants.getPermissionUrl + `?id=${Id}&ownerId=${ownerId}`;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 * update token
 * 23-05-2023
 */

export function updatetoken(changeflag) {
  return function(dispatch) {
    let ownerId = localStorage.getItem("ownerId");
    let url =
      UrlConstants.updatetoken +
      `?ownerId=${ownerId}&&changeflag=` +
      changeflag;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get User Roles new
 */

export function getUserRolesActionNew(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.userRoleNew + (id || "?id=" + localStorage.getItem("ID")),
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_ROLES,
          roles: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ROLES,
          roles: [],
        });
      }
      return response ? response.data : [];
    });
  };
}

/**
 *
 * @desc Get All Owner Contacts which are involved in INPROGRESS transcations
 */

export function getOwnerContactsAction(id) {
  let finalURL =
    UrlConstants.addContact + "/GetContactAppointment?ownerId=" + id;

  return function(dispatch) {
    return APIUtil.getMethod(finalURL, true).then((response) => {
      if (
        response.status === code.OK ||
        response.status === code.NOT_MODIFIED
      ) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 * Client fetch
 * @desc Get contacts with pagination and Searching :: New api of backend
 */
export function fetchClientsWithPagination(data) {
  return function(dispatch) {
    let url = UrlConstants.addContact + "/fetchContactsClients";
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 * Client delete
 * @desc Delete contact
 */
export function deleteClientAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.addContact + "/deleteClient?id=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.DELETE_CONTACT,
          contactResponse: response,
        });
      }
    });
  };
}

/**
 *
 * @desc Client reactivate
 */
export function reactivateClientAction(userId) {
  const url = UrlConstants.addContact + "/reactivate_client?id=" + userId;
  const postData = {
    id: userId,
  };
  return function(dispatch) {
    return APIUtil.putMethod(url, postData, true).then((response) => {
      return response;
    });
  };
}

/**
 * add client
 * @desc Add  contact Action New 22-12-2022
 */
export function addClientAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/AddClient",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage:
            "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**Client update
 * new edit artist or client updation calling.
 * 3-1-2023
 */
export function updateClientAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.addContact + "/updateClient" + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      } else {
        dispatch({
          type: types.EDIT_CONTACT,
          contactResponse: response,
        });
      }

      return response.data;
    });
  };
}

export function testTimezone(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.Testtimezones, data, true).then(
      (response) => {
        // console.log("response", response);
      }
    );
  };
}

/**
 * add client for quick appointment
 * @desc Add  contact Action New 22-12-2022
 */
export function addQuickClientAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/AddQuickClient",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage:
            "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc check existing user based on email or mobile for quick appointment
 */

export function checkEmailOrMobileForQuickApp(name, value) {
  return function(dispatch) {
    let url = "";

    if (name === "email") {
      url =
        UrlConstants.addContact +
        "/quickAppointmentEmailandMobilecheck?email=" +
        value;
    } else if (name === "mobile") {
      url =
        UrlConstants.addContact +
        "/quickAppointmentEmailandMobilecheck?mobileNumber=" +
        value;
    }

    return APIUtil.getMethod(url, true).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get all global role at roles table for admin
 * 13-2-*2023
 */

export function getRolesAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.Role, true).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_ROLES,
          roles: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ROLES,
          roles: [],
        });
      }
      return response ? response.data : [];
    });
  };
}

/**
 * 18-7-2023
 * genetrate image.
 */
export function generateImage(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.generateimage, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 18-7-2023
 * genetrate image.
 */
export function generateVariations(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.generateimagevariations,
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 * get ai model
 * 19-7-2023
 */

export function getAimodel() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getaimodel, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 * 18-7-2023
 * updating ai settings.
 */
export function updateAiModel(data) {
  // console.log("22420", data);
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.updategptmodel, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 18-7-2023
 * genetrate image.
 */
export function editImage(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.editImage, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 *
 * @desc login for public forms
 */

export function loginUserPublicFormsAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.LoginUrl + "/getSptWEbEOpurMgk",
      data,
      false
    ).then((response) => {
      if (response.status === code.OK) {
        var accessToken = response.data.data;
        localStorage.setItem("accessToken", accessToken);
        var playload = cryptoTokenDecode();
        localStorage.setItem("usertype", playload.usertype);
        localStorage.setItem("ID", playload._id);
        dispatch({
          type: types.LOGIN_USER,
          isAuthenticated: true,
          LoginMessage: "",
        });
      } else if (response.status === code.FORBIDDEN) {
        dispatch({
          type: types.LOGIN_USER,
          isAuthenticated: false,
          LoginMessage:
            "Your account is still under review. Please try again later.",
        });
      } else if (response.status === code.BAD_REQUEST) {
        dispatch({
          type: types.LOGIN_USER,
          isAuthenticated: false,
          LoginMessage: response.data,
        });
      } else {
        dispatch({
          type: types.LOGIN_USER,
          isAuthenticated: false,
          LoginMessage: "Wrong username or password.",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc List Vendor User List API call - new to get all registered and non registered artists
 */
export function artistsVendorUserAction(recordPerPage, pageIndex, searchKey) {
  var url = UrlConstants.allArtistsVendorsListUrl.replace(
    "{recordPerPage}",
    recordPerPage
  );
  var replacedUrl = url.replace("{pageIndex}", pageIndex);
  if (searchKey) {
    replacedUrl = replacedUrl + "&searchKey=" + searchKey;
  }
  return function(dispatch) {
    return APIUtil.getMethod(replacedUrl, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.VENDORS_LIST,
          vendorUsers: response.data.data,
          totalVendors: response.data.total,
        });
      } else {
        dispatch({
          type: types.VENDORS_LIST,
          vendorUsers: {},
          totalVendors: null,
        });
      }
      return response;
    });
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */
export function AddAiVersion(data) {
  return function(dispatch) {
    // console.log("data", data);
    // console.log("UrlConstants.AddAiversion", UrlConstants.AddaiVersion);
    return APIUtil.postMethod(UrlConstants.AddaiVersion, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */

export function GetAiVersion() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.GetaiVersion, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */

export function updateAiVersion(data) {
  // console.log("22420", data);
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.UpdateAiVersion, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */
export function AssignVersiontoParticularService(data) {
  return function(dispatch) {
    // console.log("data", data);
    // console.log("UrlConstants.AddAiversion", UrlConstants.AssignVersion);
    return APIUtil.postMethod(UrlConstants.assignVersionToService, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */

export function GetAllAssignedVersion() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllAiAssignedVersions, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */

export function updateAiVersionToservice(data) {
  // console.log("22420", data);
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateAiVersionToparticularService,
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 * 7-12-20223
 * Ai version control.
 */

export function GetparticularVersion(param) {
  return function(dispatch) {
    let url = UrlConstants.GetparticularVersion + "/" + param;
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc Resend register contact link
 */

export function resendRegisterContactLinkAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/resendRegisterContactLink",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_CONTACT,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
        });
      }
      return response;
    });
  };
}

export function getContactsActionsByTransactionid(id) {
  let finalURL = "";
  //  console.log("========type==================================================",type)
  // console.log("========id====",id)

  finalURL = UrlConstants.getContactsbytransactionid + "?id=" + id;

  return function(dispatch) {
    return APIUtil.getMethod(finalURL, true).then((response) => {
      if (response.status == code.OK || response.status == code.NOT_MODIFIED) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

// export function getContactsActionsByContactid(id) {
//   let finalURL = "";
//   //  console.log("========type==================================================",type)
//   // console.log("========id====",id)

//   finalURL = UrlConstants.getcontactbycontactid + "?id=" + id;

//   return function(dispatch) {
//     return APIUtil.getMethod(finalURL, true).then((response) => {
//       if (response.status == code.OK || response.status == code.NOT_MODIFIED) {
//         dispatch({
//           type: types.GET_CONTACT,
//           contacts: response.data,
//         });
//       } else {
//         dispatch({
//           type: types.GET_CONTACT,
//           contacts: [],
//         });
//       }
//       return response;
//     });
//   };
// }

export function getContactsActionsByContactid(data) {
  let ids = { ids: data };
  let finalURL = "";
  finalURL = UrlConstants.getcontactbycontactid;
  return function(dispatch) {
    return APIUtil.postMethod(finalURL, ids, true).then((response) => {
      if (response.status == code.OK || response.status == code.NOT_MODIFIED) {
        dispatch({
          type: types.GET_CONTACT,
          contacts: response.data,
        });
      } else {
        dispatch({
          type: types.GET_CONTACT,
          contacts: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get contact transaction required details in which he is involved
 */
export function fetchUserTransactionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      `${UrlConstants.addContact}/fetchUserTransaction`,
      data,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          transactionData: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          transactionData: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get contact details with profile image
 */
export function getInformationByIdAction(id, roleId) {
  let data = {
    id: id,
    roleFilter: roleId ? roleId : "",
  };
  return function(dispatch) {
    return APIUtil.postMethod(
      `${UrlConstants.addContact}/getInformationById`,
      data,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response;
    });
  };
}

/**
 * add client
 * @desc Add client by public form - checkin
 */
export function addContactByPublicFormAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addContact + "/createContactByPublicForm",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Contact created",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Active buyer agent API call
 */
export function restoreUsersAction(userID) {
  return function(dispatch) {
    let data = {
      id: userID,
    };
    let url = UrlConstants.RegisterUrl + "/restore";
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ACTIVE_USER,
          status: true,
          UserMessage: "User has been restored.",
        });
      } else {
        dispatch({
          type: types.ACTIVE_USER,
          status: false,
          UserMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * Add/ update user billing information for transactions payments
 */
export function updateUserTransPaymentAction(data) {
  data.applicationName = code.APPICATION_NAME;
  let ownerId =
    localStorage.getItem("usertype") === "VENDOR"
      ? localStorage.getItem("ownerId")
      : localStorage.getItem("ID");
  data.userId = ownerId;

  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.cardProcessUrl + "/update",
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc get user billing info of transaction payment
 */
export function getUserTransPaymentAction(id) {
  let url = UrlConstants.cardProcessUrl + "/getUserCardProcess";
  let data = {
    applicationName: code.APPICATION_NAME,
  };
  if (id) {
    data.userId = id;
  }
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc check duplicate invoice prefix
 */
export function checkDuplicateInvoicePrefixAction(data) {
  let url = UrlConstants.cardProcessUrl + "/checkDuplicateInvoicePrefix";

  let ownerId =
    localStorage.getItem("usertype") === "VENDOR"
      ? localStorage.getItem("ownerId")
      : localStorage.getItem("ID");
  data.userId = ownerId;

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc check duplicate invoice prefix
 */
export function checkDuplicatePublicUrlPostfixAction(data) {
  let url = UrlConstants.RegisterUrl + "/checkDuplicateShopUrl";

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc check duplicate invoice prefix for artists
 */
export function checkArtistDuplicatePublicUrlAction(data) {
  let url = UrlConstants.RegisterUrl + "/checkDuplicateArtistStudioUrl";

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc get user billing info of transaction payment
 */
export function getUserTransPaymentStatusAction(id) {
  let url = UrlConstants.cardProcessUrl + "/getUserCardProcessStatus";
  let data = {
    applicationName: code.APPICATION_NAME,
  };
  if (id) {
    data.userId = id;
  }
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc get user billing info of transaction payment
 */
export function getBillingPaymentStatusDetails(data) {
  let url = UrlConstants.cardProcessUrl + "/getCardProcessStatus";

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: true,
          billingPaymentDetails: response,
        });
      } else {
        dispatch({
          type: types.BILLING_PAYMENT_DETAILS,
          status: false,
          billingPaymentDetails: [],
        });
      }
      return response;
    });
  };
}


/**
 *
 * @desc Get billing setting
 */

export function updateBillingSettingAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.updatebillingSetting,
      data,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: response.data,
        });
      } else {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: [],
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc update aimodel setting
 */

export function updateAiModelSettingAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.updateAiModelSetting,
      data,
      true
    ).then((response) => {
      if (response) {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: response.data,
        });
      } else {
        dispatch({
          type: types.BILLING_SETTING,
          billingEnable: [],
        });
      }
      return response;
    });
  };
}